import PropTypes from 'prop-types';
import React from 'react';

import * as fileUtils from 'utils/file';
import { iconSelector, isInWhiteList } from 'utils/fileUtils';

import { AttachIcon } from 'components/AttachIcon/AttachIcon';
import { Spinner } from 'components/Button/style';
import { display } from 'components/ErrorView/ErrorDialog';
import Icon from 'components/Icon';
import { Mention, MentionsInput } from 'react-mentions';

import {
  ChooseFileInput,
  IconsWrapper,
  SendMessageIconWrapper,
  SendMessageInput,
  SendMessageWrapper,
} from './styles';
import i18n, { languageDirection } from '../../../i18n';
import { exactWhite } from 'utils/style/colors';

class MessageSender extends React.Component {
  state = {
    msg: '',
    files: [],
    error: undefined,
    userData: [],
    // externalUserData: [],
  };

  onChangeInput = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    if (name === 'filePicker') {
      const files = Object.values(e.target.files);
      const file = files[0];
      const fileUrl = URL.createObjectURL(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        if (file.type.match(/image\/\w*/)) {
          this.thumb.src = reader.result;
        }
        fileUtils.fileURIToBlob(fileUrl, (blob) => {
          this.blob = blob;
        });
      };
      reader.readAsDataURL(file);

      this.setState({ files, error: undefined });
    } else {
      this.setState({ [name]: value, error: undefined });
    }
  };
  onChangeMentinInput = (_, newValue) => {
    this.setState({ msg: newValue });
  };
  handleSendMsg = (e) => {
    e.preventDefault();
    const msg = this.state.msg.trim();
    const filesLength = this.state.files.length;
    if (msg !== '' || filesLength > 0) {
      if (filesLength === 0) {
        // show loading just for sending text messages
        this.setState({ sending: true });
      }
      const content = {};
      let parseContent = false;
      let file;
      content.text = msg;
      content.type = 'file';
      if (filesLength > 0) {
        content.fileName = this.state.files[0].name;
        content.size = this.state.files[0].size;
        content.fileType = this.state.files[0].type;
        parseContent = true;
        file = this.blob;
        if (content.fileType.match(/image\/\w*/)) {
          content.width = this.thumb.naturalWidth;
          content.height = this.thumb.naturalHeight;
        }
      }
      this.props
        .sendMessage(content, parseContent, file)
        .then(() => {
          this.setState({ msg: '', files: [], sending: false });
          this.filePicker.value = null;
        })
        .catch((err) => {
          this.setState({ sending: false });
          display(err);
        });
    } else {
      this.setState({
        error: i18n.t('messageCanNotBeEmpty', { ns: 'taskManager' }),
      });
    }
  };
  sendMsgOnCtrlEnter = (e) => {
    if (e.keyCode === 13 && e.ctrlKey) {
      this.handleSendMsg(e);
    }
  };

  handleCancelUpload = (e) => {
    e.preventDefault();
    this.filePicker.value = null;
    this.setState({ files: [] });
  };

  componentDidMount() {
    const users = [];
    const { possibleMembers } = this.props;

    this.props.conversation?.participantIds.forEach((userId) => {
      const name = this.props.users[userId]?.name;
      if (name)
        users.push({
          id: userId,
          display: name,
        });
    });
    possibleMembers.forEach((userId) => {
      const name = this.props.users[userId].name;
      if (name && !users.some((it) => it.id === userId))
        users.push({
          id: userId,
          display: name,
        });
    });

    this.setState({
      userData: users /* externalUserData: externalUsers */,
    });
  }

  render() {
    const {
      msg,
      error,
      files,
      sending,
      // externalUserData,
      userData,
    } = this.state;

    return (
      <>
        <SendMessageWrapper>
          <SendMessageInput>
            <MentionsInput
              value={msg}
              onChange={this.onChangeMentinInput}
              forceSuggestionsAboveCursor={true}
              allowSuggestionsAboveCursor={true}
              allowSpaceInQuery={true}
              onKeyDown={this.sendMsgOnCtrlEnter}
              className={`mention ${languageDirection() === 'rtl' ? 'textarea-dir-rtl' : 'textarea-dir-ltr'}`}
              style={{
                direction: languageDirection(),
              }}
            >
              <Mention
                trigger={'@'}
                data={userData}
                markup={'@[U__id__](__display__)'}
                displayTransform={(_, display) => `@${display}`}
                appendSpaceOnAdd={true}
              />
              <Mention
                trigger={'٬'}
                data={userData}
                markup={'@[U__id__](__display__)'}
                displayTransform={(_, display) => `@${display}`}
                appendSpaceOnAdd={true}
              />
            </MentionsInput>
            <IconsWrapper
              side={languageDirection() === 'rtl' ? 'left' : 'right'}
            >
              <ChooseFileInput
                id="filePicker"
                type="file"
                name="filePicker"
                ref={(el) => {
                  this.filePicker = el;
                }}
                onChange={this.onChangeInput}
              />
              <label htmlFor="filePicker">
                <AttachIcon onClick={this.onChangeInput} type="link" />
              </label>
              <SendMessageIconWrapper>
                {sending ? (
                  <Spinner viewBox="0 0 128 128">
                    <path
                      className="path"
                      d="M75.4 126.6a11.4 11.4 0 0 1-2.1-22.6 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.3 4.9h0a63.8 63.8 0 0 1-47.8 48.1v0a11.4 11.4 0 0 1-2.9z"
                    />
                  </Spinner>
                ) : (
                  <Icon
                    type={
                      languageDirection() === 'rtl'
                        ? 'chevrons-left'
                        : 'chevrons-right'
                    }
                    color={exactWhite}
                    onClick={this.handleSendMsg}
                  />
                )}
              </SendMessageIconWrapper>
            </IconsWrapper>
          </SendMessageInput>
        </SendMessageWrapper>
        {files.length > 0 &&
          files.map((file) => (
            <span key={file.name}>
              {!isInWhiteList(file.type) && (
                <p className="red-text">
                  {i18n.t('canNotViewInMobile', { ns: 'taskManager' })}
                </p>
              )}
              <div
                key={file.name}
                className="card-panel"
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <img
                  src={iconSelector(file.type)}
                  ref={(el) => {
                    this.thumb = el;
                  }}
                  className="thumb"
                  alt="thumb"
                />
                <span style={{ wordBreak: 'break-all' }}>{file.name}</span>
                <a href="#!" onClick={this.handleCancelUpload}>
                  <Icon type={'x'} />
                </a>
              </div>
            </span>
          ))}
        {error && <span className="red-text">{error}</span>}
      </>
    );
  }
}

MessageSender.propTypes = {
  sendMessage: PropTypes.func.isRequired,
  conversation: PropTypes.object.isRequired,
  users: PropTypes.object.isRequired,
};

export default MessageSender;
